var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useTranslation } from 'react-i18next';
var useTranslate = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var tWithField = function (key, fieldKey, options) {
        var field = t(fieldKey);
        return t(key, __assign(__assign({}, options), { field: field, framework: 'React' }));
    };
    var tWithFunction = function (key, functionKey, options) {
        var _function = t(functionKey);
        return t(key, __assign(__assign({}, options), { function: _function, framework: 'React' }));
    };
    return {
        translate: t,
        tWithField: tWithField,
        tWithFunction: tWithFunction,
        currentLanguage: i18n.language
    };
};
export default useTranslate;
